<app-page-loader></app-page-loader>
<router-outlet></router-outlet>
<app-instalar-app></app-instalar-app>
